<template>
	<c-modal @close="close" :title="'Status bewerken'">

		<c-form ref="form" @valid="submit" class="margin-t-40">

            <c-select
                :label="'Status'"
                :horizontal="true"
                :options="getStatusses()"
                :required="false"
                v-model="status"
                :name="'name'"
				:ValueName="'id'">
            </c-select>

			<div class="row collapse align-right">
				<div class="columns shrink">
					<c-button class="margin-t-32 margin-b-16 no-margin-b" type="submit">Opslaan</c-button>
				</div>
			</div>

		</c-form>

	</c-modal>
</template>

<script>
import Form from '@mixins/Form';
import CModal from '@components/Modal';

import { mapState } from 'vuex';
import { ValidationError } from '@app/errors';

export default {
	mixins: [Form],
	components: {
		CModal,
	},
    props: {
        item: {
            required: false
        },
		delivery: {
			required: false
		},
		type: {
			required: false,
			default: 'item'
		},
    },
	data() {
		return {
            status: ''
		}
	},
	methods: {
		getStatusses(){
			if(this.type == 'delivery'){
				return [
					{
						id: this.$constants.status.REPARATIE_AANGEVRAAGD,
						name: 'Reparatie aangevraagd'
					},
					{
						id: this.$constants.status.REPARATIE_ONTVANGEN,
						name: 'Reparatie ontvangen'
					},
					{
						id: this.$constants.status.REPARATIE_IN_BEHANDELING,
						name: 'Reparatie in behandeling'
					},
					{
						id: this.$constants.status.REPARATIE_AFGEROND,
						name: 'Reparatie afgerond'
					},
					{
						id: this.$constants.status.WACHTEN_OP_ONDERDELEN,
						name: 'Wachten op onderdelen'
					},
					{
						id: this.$constants.status.WACHTEN_OP_GOEDKEURING_OFFERTE,
						name: 'Wachten op goedkeuring offerte'
					}
					
				]
			}
			else {
				return [
					{
						id: this.$constants.status.IN_GEBRUIK,
						name: 'In gebruik'
					},
					{
						id: this.$constants.status.REPARATIE,
						name: 'Reparatie'
					},
					{
						id: this.$constants.status.OP_AFROEP,
						name: 'Op afroep'
					},
					{
						id: this.$constants.status.EOL,
						name: 'EOL'
					},
					{
						id: this.$constants.status.IN_BEHANDELING,
						name: 'In behandeling'
					},
					{
						id: this.$constants.status.VERMIST,
						name: 'Gestolen/vermist'
					},
					{
						id: this.$constants.status.VOORRAAD_KLANTLOCATIE,
						name: 'Voorraad klantlocatie'
					}
				]
			}
		},
		submit() {
			if(this.type == 'delivery'){
				this.$xhr.post('/api/deliveries/' + this.delivery.id + '/change-repair-status', {status: this.status}).then( ( {result}) => {
					this.close();
					this.$emit('added');
					this.$store.dispatch('toast/success', {title: 'Status aanpassen', text: 'De status is aangepast'});
				}).catch( (e) => {
					if (e instanceof ValidationError) {
						this.$refs.form.setErrors(e.errors);
					}
					this.$store.dispatch('toast/alert', {title: 'Status aanmaken', text: 'Er is helaas iets fout gegaan bij het wijzigen van de status'});
				});
			}
			else {
				let data = {
                status_id: this.status,
                product_id: this.item.product.id,
				};
				data._method = 'PUT';
				this.$xhr.post('/api/items/' + this.item.id, data).then( ( {result}) => {
					this.close();
					this.$emit('added');
					this.$store.dispatch('toast/success', {title: 'Status aanpassen', text: 'De status is aangepast'});
				}).catch( (e) => {
					if (e instanceof ValidationError) {
						this.$refs.form.setErrors(e.errors);
					}
					this.$store.dispatch('toast/alert', {title: 'Status aanmaken', text: 'Er is helaas iets fout gegaan bij het wijzigen van de status'});
				});
			} 
		},
		close() {
			this.$emit('close');
		},
		load(){
			if(this.type == 'delivery'){
				this.status = this.delivery.events[0] ? this.delivery.events[0].status.id : '';
			}
			else{
				this.status = this.item.status.id;
			}
		}
	},
	mounted(){
		this.load();
	}
}
</script>
